import { defineMessages } from 'react-intl';

export default defineMessages({
  resetApplicationTitle: {
    id: 'ResetAffordaPortalApplicationModal.resetApplicationTitle',
    defaultMessage: 'Warning! Reset Confirmation',
  },
  resetApplicationMessageParagraph1: {
    id: 'ResetAffordaPortalApplicationModal.resetApplicationMessageParagraph1',
    defaultMessage:
      'Resetting will **clear all applications** for this household and require every applicant to start over ' +
      'from the beginning, which may include re-registering any claimed Portal accounts.',
  },
  resetApplicationMessageParagraph2: {
    id: 'ResetAffordaPortalApplicationModal.resetApplicationMessageParagraph2',
    defaultMessage:
      'Once confirmed, the household will be **moved back to Manage Prospects** until the application is ' +
      'restarted, at which point they will be converted back to Applicants.',
  },
  cancel: {
    id: 'ResetAffordaPortalApplicationModal.cancel',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'ResetAffordaPortalApplicationModal.confirm',
    defaultMessage: 'Confirm & Reset',
  },
  feesPaidTooltip: {
    id: 'ResetAffordaPortalApplicationModal.feesPaidTooltip',
    defaultMessage: 'Cannot reset the application once fees have been paid',
  },
  resetButtonText: {
    id: 'ResetAffordaPortalApplicationModal.resetButtonText',
    defaultMessage: 'Reset Application',
  },
  resetButtonDisabledText: {
    id: 'ResetAffordaPortalApplicationModal.resetButtonDisabledText',
    defaultMessage: 'Reset Application',
  },
});
